import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { sendValidateNewAccount, setAuthorizedIdNew } from "../../../domain/validation/validationActions";
import { closeModal } from "../../../domain/ui/uiActions";
import AuthIndividualForm from "../../forms/public/AuthIndividualForm";
import { FormattedMessage } from "react-intl";
class AuthIndividual extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div>
				<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="authIndividual.header" defaultMessage="Authorized Person Information"/>
					</h1>
				</div>
				<div className="vr vr_x5">
					<div className="text">
						<FormattedMessage tagName="p" id="authIndividual.intro" defaultMessage={"Oops! The name you provided does not match our record of authorized individuals. "
            + "Please select your name from the following list."}/>
					</div>
				</div>
				<div className="vr vr_x5">
					<div className="sides sides_x4S">
						<AuthIndividualForm authIndividuals={this.props.validationInfo.authorized || []} closeModal={this.props.closeModal} fieldErrors={this.props.validationFieldErrors} modalTrigger="authIndividual" requestData={this.props.validationInfo.validationRequest} sendValidation={this.props.sendValidateNewAccount} setAuthId={this.props.setAuthorizedIdNew} isLoading={this.props.validationIsLoading}/>
					</div>
				</div>
				<div className="vr vr_x5">
					<div className="text">
						<FormattedMessage tagName="p" id="authIndividual.contact" defaultMessage={"If your name is not on this list, and you believe that you are authorized, "
            + "please {link}"} values={{
            link: (<Link className="link" to="/public/contact">
										<FormattedMessage id="authIndividual.contact.link" defaultMessage="contact us."/>
									</Link>)
        }}/>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    validationFieldErrors: state.validation.fieldErrors,
    validationIsLoading: state.validation.isLoading,
    validationInfo: state.validation
});
const bindActionsToProps = {
    closeModal,
    sendValidateNewAccount: (value) => sendValidateNewAccount(value),
    setAuthorizedIdNew
};
/* Create and export container component that wraps AuthIndividual for property binding */
export default connect(mapStateToProps, bindActionsToProps)(AuthIndividual);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/AuthIndividual.tsx